import gql from 'graphql-tag'

export const GET_PART_BRANDS = gql`
  query PartBrands($filter: GetPartBrandsFilter) {
    partBrands(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      partBrands {
        data {
          partBrandId
          companyId
          brand
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_PART_BRAND_BY_ID = gql`
  query PartBrand($filter: GetPartBrandFilter!) {
    partBrand(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      partBrand {
        partBrandId
        companyId
        brand
      }
    }
  }
`

export const CREATE_PART_BRAND = gql`
  mutation CreatePartBrand($input: CreatePartBrandInput!) {
    createPartBrand(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createPartBrand {
        partBrandId
      }
    }
  }
`

export const UPDATE_PART_BRAND = gql`
  mutation UpdatePartBrand($input: UpdatePartBrandInput!) {
    updatePartBrand(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updatePartBrand {
        partBrandId
        brand
      }
    }
  }
`

export const DELETE_PART_BRAND = gql`
  mutation DeletePartBrand($input: DeletePartBrandInput!) {
    deletePartBrand(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`
